import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { isNullOrUndefined } from 'util';
import { SitesObject } from 'src/app/models/orders/order-details-sites/sites-tab-object-model';
import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';

@Component({
  selector: 'app-sites-addresses-table',
  templateUrl: './addresses-table.component.html',
  styleUrls: ['./addresses-table.component.css']
})
export class AddressesTableComponent implements OnChanges {

  @Input() sites: Array<SitesObject>;
  @Input() dataSourceId: number;

  formatName: string;
  formatsList: Array<string>;
  dataSource: MatTableDataSource<CharacteristicObject>;

  columnsToDisplay: string[] = ['name', 'value'];

  constructor() { }

  ngOnChanges() {
    if (!isNullOrUndefined(this.sites)) {
      this.getAdressInEspecificFormat();
      this.updateFormat(this.formatName);
    }
  }

  private getAdressInEspecificFormat() {
    if (!isNullOrUndefined(this.sites.length)) {
      this.formatsList = this.sites[this.dataSourceId].getAllFormats();
      let newFormat = null;
      if (this.formatsList.length > 0) {
        newFormat = this.formatsList[0];
      }
      this.updateFormat(newFormat);
    }
  }

  private updateFormat(newFormat: string) {
    this.formatName = newFormat;
    if (!isNullOrUndefined(newFormat) && !isNullOrUndefined(this.sites) && this.sites.length > this.dataSourceId) {
      this.dataSource = new MatTableDataSource<CharacteristicObject>(this.sites[this.dataSourceId].getAddressesByFormat(this.formatName));
    } else {
      this.dataSource = new MatTableDataSource<CharacteristicObject>(new Array<CharacteristicObject>());
    }
  }
}